/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-nested-ternary */
// import { useFormik } from 'formik';
import { useState, useEffect } from 'react';
// material
import { Container, Stack, Button, Tabs, Tab } from '@mui/material';
import { Icon } from '@iconify/react';
import plusFill from '@iconify/icons-eva/plus-fill';
import { useDispatch, useSelector } from 'react-redux';
import EmptyDashboardChart from '../components/EmptyDashboardChart';
import { ADD_NEW_REQUEST, ASSIGN_DATA } from '../redux/pendingRequest.reducer';
import { ADD_CLASSES, ADD_TEACHER } from '../redux/constants';
import InviteTable from '../components/tables/InviteTables';
import { API_LIMIT_DATA } from '../utils/constants';
import Page from '../components/Page';
// import TableList from './TableList';
import AddPopup from '../components/AddPopup';
// import ClassIcon from '../svg/ClassIcon';
// import palette from '../theme/palette';
import { fetchClasses } from '../service/class.service';
import { getAllPendingRequest } from '../service/invite.service';
import UserTable from '../components/tables/UserTable';
import { fetchTeacherByOrg } from '../service/teacher.service';
import { TableSkeleton } from '../fl-components/table';

const inviteTabs = [
  { id: 1, title: 'Teachers' },
  { id: 2, title: 'Invites' }
];

// ----------------------------------------------------------------------

export default function Teachers() {
  const selectedOrg = useSelector((state) => state.org.selectedOrg);
  const orgLoading = useSelector((state) => state.org.orgLoading);
  const teachersList = useSelector((state) => state.userData.teachers);
  const classList = useSelector((state) => state.classes.classData);
  const classOffset = useSelector((state) => state.classes.offset);
  const classHasMore = useSelector((state) => state.classes.hasMore);
  const inviteList = useSelector((state) => state.pendingRequest.request);
  const dispatch = useDispatch();

  // Component state
  const [isTeacherPopupOpen, setTeacherPopup] = useState(false);
  const [currentTab, setCurrentTab] = useState('Teachers');
  // const [inviteList, setInviteList] = useState([]);
  const [isClassLoading, setIsClassLoading] = useState(false);
  // Student loading
  const [teacherLoading, setTeacherLoading] = useState(teachersList === null);
  // Invite loading
  const [inviteLoading, setInviteLoading] = useState(true);

  const setClassesData = async () => {
    const orgClasses = await fetchClasses(selectedOrg?.id ?? selectedOrg?.orgId ?? '');
    if (orgClasses) {
      dispatch({
        type: ADD_CLASSES,
        payload: {
          classes: orgClasses.results,
          offset: classOffset + 1
        }
      });
    }
  };

  const fetchNextData = async () => {
    if (classHasMore) {
      const res = await fetchClasses(
        selectedOrg?.id ?? selectedOrg?.orgId ?? '',
        classOffset,
        API_LIMIT_DATA
      );
      if (res) {
        dispatch({
          type: ADD_CLASSES,
          payload: {
            classes: res.results,
            offset: classOffset + 1
          }
        });
      }
      setIsClassLoading(false);
    }
  };

  const fetchTeacherList = async () => {
    const res = await fetchTeacherByOrg(selectedOrg?.id ?? selectedOrg?.orgId);
    if (res) {
      dispatch({ type: ADD_TEACHER, payload: res });
      // setTeachersList(res);
      setTeacherLoading(false);
    } else {
      setTeacherLoading(false);
    }
  };

  const fetchInviteList = async () => {
    const res = await getAllPendingRequest(selectedOrg?.id ?? selectedOrg?.orgId);
    if (res) {
      dispatch({ type: ASSIGN_DATA, payload: { data: res } });
      setInviteLoading(false);
    } else {
      setInviteLoading(false);
    }
  };

  useEffect(() => {
    setInviteLoading(inviteList === null);
    setTeacherLoading(teachersList === null);
  }, [teachersList, inviteList]);

  useEffect(() => {
    if (inviteList === null && !orgLoading) {
      fetchInviteList();
    } else {
      setInviteLoading(false);
    }
    if (teachersList === null && !orgLoading) {
      fetchTeacherList();
    } else {
      setTeacherLoading(false);
    }
  }, [orgLoading]);

  useEffect(() => {
    if (classList === null && !orgLoading) {
      setClassesData();
    }
  }, [orgLoading]);

  const handlePopup = () => {
    setTeacherPopup(!isTeacherPopupOpen);
  };

  return (
    <Page title="Teacher">
      <Container>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={{ xs: 1, sm: 2, md: 4 }}
          alignItems={{ sm: 'center' }}
          justifyContent={{ sm: 'space-between' }}
          mb={5}
        >
          <Tabs
            value={currentTab}
            onChange={(e, newValue) => setCurrentTab(newValue)}
            variant="scrollable"
            scrollButtons={false}
            aria-label="scrollable prevent tabs example"
          >
            {inviteTabs.map((t, i) => (
              <Tab label={t.title} key={i} value={t.title} />
            ))}
          </Tabs>
          <Button
            variant="contained"
            onClick={() => handlePopup()}
            to="#"
            startIcon={<Icon icon={plusFill} />}
          >
            New Teacher
          </Button>
        </Stack>
        {currentTab === 'Teachers' ? (
          <>
            {teacherLoading ? (
              <TableSkeleton width="100%" />
            ) : teachersList.length > 0 ? (
              <UserTable userList={teachersList} filterOption={classList} type="teacher" />
            ) : (
              <EmptyDashboardChart text="Oops! No teacher found" />
            )}
          </>
        ) : (
          <>
            {inviteLoading ? (
              <TableSkeleton width="100%" />
            ) : inviteList.filter((iv) => iv.role === 'teacher').length > 0 ? (
              <InviteTable
                list={inviteList.filter((iv) => iv.role === 'teacher')}
                filterOption={classList}
              />
            ) : (
              <EmptyDashboardChart text="Oops! No invite list found" />
            )}
          </>
        )}
        <AddPopup
          isOpen={isTeacherPopupOpen}
          title="Add Teacher"
          handleClosePopup={() => handlePopup()}
          studentClassList={classList || []}
          popUpType="teacher"
          fetchNextData={() => {
            fetchNextData();
            setIsClassLoading(true);
          }}
          isClassLoading={isClassLoading}
          hasMore={classHasMore}
          addedPopupRes={(res) => {
            dispatch({
              type: ADD_NEW_REQUEST,
              payload: res
            });
          }}
        />
      </Container>
    </Page>
  );
}
